import * as React from 'react';

export interface RichTextEditorLightProps {
  disabled?: boolean;
  onChange?: (value: string) => void;
  value?: string;
  watchValue?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  styles?: any;
  classNames?: Array<string>;
  autoFocus?: boolean;
}

export const RichTextEditorLight = (props: RichTextEditorLightProps): React.JSX.Element => {
  const [valueInitial, setInitialValue] = React.useState<string>(props.value);
  const editableRef = React.useRef<HTMLDivElement>(null);

  let style = {
    height: 'auto',
    lineHeight: '1.8',
  };
  if (props.styles) {
    style = { ...style, ...props.styles };
  }

  React.useEffect(() => {
    if (props.watchValue && props.watchValue === true) {
      setInitialValue(props.value);
    }
  }, [props.value]);

  React.useEffect(() => {
    if (props.autoFocus && editableRef.current) {
      editableRef.current.focus();
    }
  }, []);

  return (
    <div
      className="form-control border-secondary"
      style={{
        height: 'auto',
        lineHeight: '1.8',
      }}
      dangerouslySetInnerHTML={{ __html: (valueInitial || '').replace(/\n/g, '<br />') }}
      contentEditable={!props.disabled}
      onInput={(e) => {
        if (props.onChange) {
          const element = e.currentTarget as HTMLDivElement;
          const value = element.innerText;
          props.onChange(value);
        }
      }}
      onKeyDown={(e) => {
        if (props.onKeyDown) {
          props.onKeyDown(e);
        }
      }}
    />
  );
};
